module.exports = __webpack_public_path__ + "img/3.cb71806f.jpg";